import { LogOut, Mail } from 'iconoir-react';
import { useContext, useEffect } from 'react';

import Button from '@superfunnel/ui-core/Button';

import { AuthContext } from '../contexts/AuthContext';

import logo from '@/assets/images/logo.png';

const CALENDLY_DEMO_URL = 'https://calendly.com/superfunnelai/sales';
const CALENDLY_WIDGET_SCRIPT =
  'https://assets.calendly.com/assets/external/widget.js';

export default function BookDemo() {
  const { firebaseUser, logout } = useContext(AuthContext);

  useEffect(() => {
    if (document.querySelector(`script[src="${CALENDLY_WIDGET_SCRIPT}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = CALENDLY_WIDGET_SCRIPT;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const calendlyParams = new URLSearchParams({
    hide_landing_page_details: '1',
    hide_event_type_details: '1',
  });
  if (firebaseUser?.email) {
    calendlyParams.set('email', firebaseUser.email);
  }
  if (firebaseUser?.displayName) {
    calendlyParams.set('name', firebaseUser.displayName);
  }
  const calendlyUrl = `${CALENDLY_DEMO_URL}?${calendlyParams.toString()}`;

  return (
    <main className="flex h-screen flex-col overflow-hidden bg-white">
      <div className="mx-auto grid min-h-0 w-full max-w-6xl flex-1 grid-cols-1 items-center gap-10 px-6 py-6 lg:grid-cols-2 lg:gap-16">
        <div className="text-center lg:text-left">
          <img className="mx-auto h-9 lg:mx-0" src={logo} alt="SuperFunnel" />
          <p className="mt-3 text-base font-semibold text-brand-500">
            You&apos;re on the list
          </p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Book a demo to get access
          </h1>
          <p className="mt-4 max-w-xl text-base leading-7 text-gray-600 lg:mx-0">
            SuperFunnel is available by invitation. Book a quick demo with our
            team and we&apos;ll get your account set up right away.
          </p>
          <div className="mt-6 flex items-center justify-center gap-3 lg:justify-start">
            <Button variant="outline" size="sm" onClick={logout}>
              <LogOut className="size-4" />
              Logout
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                window.location.href = 'mailto:support@superfunnel.ai';
              }}
            >
              <Mail className="size-4" />
              Contact support
            </Button>
          </div>
        </div>

        <div
          className="calendly-inline-widget h-full max-h-175 w-full"
          data-url={calendlyUrl}
          style={{ minWidth: '320px' }}
        />
      </div>
    </main>
  );
}
